import Vue from 'vue'
import axios from 'axios'
import i18n from '../i18n'
import { Message } from 'element-ui'
import store from '../store/index'
import { getToken } from '@/utils/auth'

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.withCredentials = false
// axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.timeout = 60000

axios.interceptors.request.use(config => {
    if (getToken()) {
      config.headers['token'] = getToken()
    }

    if (config.method === 'post') {
      config.params = undefined
    }

    return config
  }, error => Promise.resolve(error.response || { data: {} })
)

axios.interceptors.response.use(response => {
    if (response.data && response.data.code !== 20000 && response.data.message) {
      Message.error({
        message: response.data.message,
        duration: 3000
      })
    }
    if (response.data && (response.data.code === 50008 || response.data.code === 50012 || response.data.code === 50014)) {
      store.dispatch('user/logout')
      setTimeout(() => {
        location.href = '/login'
      }, 300)
    }
    return response
  }, error => {
    if (error.response && error.response.data.message) {
      Message.error({
        message: error.response.data.message,
        duration: 3000
      })
    } else if (error.message) {
      if (error.code && error.code === 'ECONNABORTED') {
        Message.error({
          message: i18n.t('request.timeout'),
          duration: 3000
        })
      } else {
        Message.error({
          message: error.message,
          duration: 3000
        })
      }
    }
    return Promise.resolve(error.response || { data: {} })
  }
)

export const fetch = (url, data = {}, method = 'post', obj = {}) => {
  return new Promise((resolve) => {
    let config = {
      url,
      data: method === 'post' ? data : {},
      params: method === 'post' ? {} : data,
      method
    }

    if (Object.prototype.toString.call(obj.headers) === '[object Object]' && Object.keys(obj.headers).length > 0) {
      config.headers = obj.headers
    }

    if (Object.prototype.toString.call(obj.timeout) === '[object Number]') {
      config.timeout = obj.timeout
    }

    axios(config).then(res => resolve(res.data))
  })
}

Vue.prototype.$fetch = fetch
